import { CommonMessages } from '../../common.messages';

export const PlanAddMessages = {
    PlanCreationFailed: {
        key: 'PlanCreationFailed',
        message: 'Error while processing request. Unable to create a Plan.'
    }, 
    PlanCreationSucceed: {
        key: 'PlanCreationSucceed',
        message: 'Plan is successfully created.'
    }, 
    PlanUpdateFailed: {
        key: 'PlanUpdateFailed',
        message: 'Error while processing request. Unable to update a Plan.'
    },
    PlanUpdateSucceed: {
        key: 'PlanUpdateSucceed',
        message: 'Plan is successfully updated.'
    },
    ...CommonMessages
};
